import { UploadedFileRepository } from '../../domain/repository';
import { UploadedFileRepositoryImpl } from '../repository';

export const uploadedFileProviders = [
  {
    provide: UploadedFileRepository,
    useExisting: UploadedFileRepositoryImpl,
  },
];


